import React, { useState, useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MainLoader from "./components/MainLoader/MainLoader";
import Login from "./screens/Login/Login";
import CreateUser from "./screens/CreateUser/CreateUser";
import Information from "./screens/Information/Information";
import ModifyUser from "./screens/ModifyScreen/ModifyUser";
import CustomerSummary from "./screens/Summary/CustomerSummary";
import Planning from "./screens/VkPlanning/Planning";
import PrivateRoutes from "./components/PrivateRouter/PrivateRoutes";
import ChooseTemplate from "./screens/Template/ChooseTemplate/ChooseTemplate";
import TemplatesNew from "./screens/Template/Template_new";
import EkPlanning from "./screens/EkPlanning/EkPlanning";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  if (loading) {
    return <MainLoader />;
  }
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/information" element={<Information />} />
          <Route path="/modify-user" element={<ModifyUser />} />
          <Route path="/customer-summary" element={<CustomerSummary />} />
          <Route path="/vk-planning" element={<Planning />} />
          <Route path="/vk-planning/:customerID/:shipTo/:year/:div/:city/:customerName/:vtr/:isEditable" element={<Planning />} />
          <Route path="/template" element={<ChooseTemplate/>} />
          <Route path="/newScreen-templateN" element={<TemplatesNew />} />
          {/* <Route path="/newScreen-template/:customerID" element={<Template />} /> */}
          <Route path="/newScreen-templateN/:soldTo/:division/:planYear" element={<TemplatesNew />} />
          <Route path="/ek-planning" element={<EkPlanning/>}/>
          <Route path="/ek-planning/:customerID" element={<EkPlanning />} />

        </Route>
        <Route path="/" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
